var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltioYear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1819",
    "data-name": "Group 1819",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.13,
    height: 95.454,
    viewBox: "0 0 89.13 95.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.172,
    y1: 0.5,
    x2: 0.874,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36953e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ab53f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M44.565,95.454c-28.857,0-39.347-2.748-39.779-2.865L0,91.294,1.278,86.5C15.348,33.752,39.789,5.448,40.823,4.268L44.565,0l3.742,4.268C49.341,5.448,73.782,33.752,87.853,86.5l1.278,4.79-4.786,1.3C83.911,92.706,73.423,95.454,44.565,95.454ZM12.349,83.833c5.407.731,15.583,1.669,32.216,1.669s26.805-.938,32.216-1.67c-10.269-35.482-25.3-58.735-32.218-68.2A171.842,171.842,0,0,0,34.683,30.87,238.8,238.8,0,0,0,12.349,83.833ZM48.306,10.828Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltioYear);
export default __webpack_public_path__ + "static/media/altio-year.586c7a7dfab589de6dc750e16a80ce91.svg";
export { ForwardRef as ReactComponent };